/* eslint-disable */
// import axios from "axios";
// import App from '../../App.vue';
import Vue from "vue";

export default{
    state: {
    
    },
    
    mutations: {
        
    },

    getters:{
        
    },
    
    actions: {
        AUTH:({commit},payload)=>{
            return new Promise((resolve,reject)=>{
                Vue.prototype.$http
                .post(process.env.VUE_APP_API_URL+'auth',payload) 
                .then(({data,status}) => {
                    resolve(data);
                })
                .catch(error=>{
                    
                    reject(error)
                })
            })
        },

        LOGOUT:({commit},payload)=>{
            return new Promise((resolve,reject)=>{
                Vue.prototype.$http
                .post('logout',payload)
                .then(({data,status})=>{
                    resolve({data,status})
                })
                .catch(error=>{
                    reject(error)
                })
            })
        }
    },
}